<template>
  <div>
    <el-input-number
      :key="key"
      :value="count"
      :disabled="disabled"
      :min="minCount"
      :max="item && item.max_count || Infinity"
      :precision="0"
      size="small"
      style="width: 100%;"
      @change="onCountChange"
    />
    <el-tag
      v-if="compareType === 'completion' && completion !== null"
      size="small"
      style="margin-top: 5px;"
      :type="completion === count ? 'success': 'warning'"
    >
      Teljesítve: {{ Math.abs(completion) }} {{ item.product_pack_type && item.product_pack_type.count_per_pack === 1 ? 'db' : item.product_pack_type.pack_type.name }}
    </el-tag>
    <el-tag
      v-if="difference > 0 && compareType === 'diff'"
      size="small"
      type="danger"
      style="margin-top: 5px;"
    >
      Többlet: {{ Math.abs(difference) }} {{ item.product_pack_type && item.product_pack_type.count_per_pack === 1 ? 'db' : item.product_pack_type.pack_type.name }}
    </el-tag>
    <el-tag
      v-if="difference < 0 && compareType === 'diff'"
      size="small"
      type="danger"
      style="margin-top: 5px;"
    >
      Hiány: {{ Math.abs(difference) }} {{ item.product_pack_type && item.product_pack_type.count_per_pack === 1 ? 'db' : item.product_pack_type.pack_type.name }}
    </el-tag>
    <el-tag
      v-if="showRowWarning && rowWarning === 'not-whole'"
      size="small"
      type="danger"
      style="margin-top: 5px;"
    >
      Nem egész sor (még {{ missingForWholeRow }} {{ item.product_pack_type.count_per_pack === 1 ? 'db' : item.product_pack_type.pack_type.name }} kell)
    </el-tag>
    <el-tag
      v-if="showRowWarning && rowWarning === 'not-set'"
      size="small"
      type="warning"
      style="margin-top: 5px;"
    >
      Kiszerelés/sor nincs megadva
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    count: {
      type: Number,
      default() {
        return 1;
      },
      required: false,
    },
    item: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
    minCount: {
      type: Number,
      default() {
        return 1;
      },
      required: false,
    },
    compareItems: {
      type: Array,
      default() {
        return null;
      },
      required: false,
    },
    compareType: {
      type: String,
      default() {
        return 'diff';
      },
      required: false,
    },
    showRowWarning: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
  },
  data() {
    return {
      key: 0,
    };
  },
  computed: {
    completion() {
      if (this.item.id && this.compareItems && this.compareType === 'completion') {
        return this.compareItems && this.compareItems.reduce((acc, curr) => acc + curr.count, 0) || 0;
      } else {
        return null;
      }
    },
    difference() {
      if (this.count !== undefined && this.compareItems && this.compareType === 'diff') {
        return this.item.count - this.compareItems.reduce((acc, curr) => acc + curr.count, 0);
      } else {
        return null;
      }
    },
    rowWarning() {
      if (!this.showRowWarning) return null;
      const countPerRow = this.item.product_pack_type && this.item.product_pack_type.count_per_row;
      if (!countPerRow) return 'not-set';
      if (this.count % countPerRow !== 0) return 'not-whole';
      return null;
    },
    missingForWholeRow() {
      if (this.rowWarning !== 'not-whole') return 0;
      const countPerRow = this.item.product_pack_type.count_per_row;
      return countPerRow - (this.count % countPerRow);
    },
  },
  watch: {
    count() {
      this.key++;
    },
  },
  methods: {
    onCountChange(count) {
      this.$emit('change', parseInt(count));
    },
  },
};
</script>
